import { LocalStorageItems } from 'shared/constants';

import { AvailableTenant } from '../types';

export default function changeTenant(tenant: AvailableTenant) {
    localStorage.setItem(LocalStorageItems.TENANT_ID, tenant.id);
    window.location.reload();
}
